import { ComponentStyleConfig } from '@chakra-ui/react';

export const SelectableCard: ComponentStyleConfig = {
  baseStyle: () => ({
    bgColor: 'white',
    boxShadow: 'none',
    borderRadius: 'md',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: 'neutral.100',
    _hover: {
      bgColor: 'neutral.50',
      boxShadow: 'none',
      borderColor: 'neutral.100',
    },
    _selected: {
      bg: 'primary.100',
      borderColor: 'primary.300',
      _hover: {
        bgColor: 'primary.100',
        borderColor: 'primary.300',
      },
    },
  }),
};
